import { createApi, fetchBaseQuery, BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query/react';
import { AlertUtils } from '../../shared/utils/alert';

const baseQuery = fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API_BASE_URL,
    prepareHeaders: (headers) => {
        const token = localStorage.getItem('admin_token');
        if (token) {
            headers.set('Authorization', `Bearer ${token}`);
        }
        return headers;
    }
});

const baseQueryWithReauth: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
    args,
    api,
    extraOptions
) => {
    let result = await baseQuery(args, api, extraOptions);
    
    if (result.error) {
        if (result.error.status === 401) {
            // Do not intercept 401s on the login/signup pages, let the component handle the invalid credentials error
            if (window.location.pathname !== '/login' && window.location.pathname !== '/signup') {
                localStorage.removeItem('admin_token');
                localStorage.removeItem('admin_user');
                api.dispatch(apiSlice.util.resetApiState());
                
                AlertUtils.warning('Session Expired', 'Your session has expired or is invalid. Please log in again.')
                    .then(() => {
                        window.location.href = '/login';
                    });
            }
        } else if (result.error.status === 402) {
            // Payment Required: user ran out of credits or has no active subscription.
            const errData = result.error.data as any;
            const detail = errData?.message || 'You have insufficient credits to perform this action.';
            AlertUtils.error(
                'Out of Credits',
                `${detail} Visit the Billing page to top up or upgrade your plan.`
            ).then(() => {
                window.location.href = '/admin/billing';
            });
        } else if (result.error.status === 403) {
            AlertUtils.error('Access Denied', 'You do not have permission to perform this action.');
        }
    }
    
    return result;
};

export const apiSlice = createApi({
    reducerPath: 'api',
    baseQuery: baseQueryWithReauth,
    tagTypes: ['KnowledgeDocs', 'Sessions', 'CalendarConnections', 'CalendarEvents', 'CalendarBriefing', 'CrmConnections', 'BillingBalance', 'BillingHistory'],
    endpoints: () => ({}),
});

// export const { useGetItemsQuery } = apiSlice;
